import Vue from 'vue'

Object.defineProperties(Vue.prototype, {
    $services: {
        // полезные глобальные утилиты доступные через this.$services
    }
})
